import { Component, h, Prop } from '@stencil/core';

/**
 * If the main navigation item is only used as a link, use this component.
 *
 * @tag dc-ui-header-main-nav-link
 * @since 1.9.0
 *
 **/

@Component({
  tag: 'dc-ui-header-main-nav-link',
  styleUrl: '../dc-ui-header-main-nav-item/dc-ui-header-main-nav-item.scss',
  shadow: true,
})
export class DcUiHeaderMainNavLink {
  @Prop() label!: string;
  @Prop() href!: string;
  @Prop() target?: '_blank' | '_self' | '_parent' | '_top';

  render() {
    return (
      <div class="main-nav-item">
        <a
          href={this.href}
          target={this.target}
          class="main-nav-item-trigger">
          <span class="main-nav-item-title">{this.label}</span>
        </a>
      </div>
    );
  }
}
